import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import KeycloakService from "./components/config/KeycloakService";
import UserProvider from "./components/user/UserProvider";
import HttpClient from "./utilities/functions/HttpClient";
import LoadingSpinnerProvider from "./utilities/components/LoadingSpinnerProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
const renderApp = () =>
  root.render(
    <UserProvider>
      <LoadingSpinnerProvider>
        <App />
      </LoadingSpinnerProvider>
    </UserProvider>,
  );

KeycloakService.initKeycloak(renderApp);
HttpClient.configure();
